export default __webpack_public_path__ + "a77c4850494ae4df11b1e6046becff45.svg";